import React, { useState } from 'react';
import './css/ToggleButton.css';

const ToggleButton = () => {
  const [isChecked, setIsChecked] = useState(false);

  const handleChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <input 
      type="checkbox" 
      className="switch" 
      checked={isChecked} 
      onChange={handleChange} 
    />
  );
};
export const ToggleButtonCustom = ({isChecked, onChange}) => {
  return (
    <input 
      type="checkbox" 
      className="switch" 
      checked={isChecked} 
      onChange={onChange} 
    />
  );
};


export default ToggleButton;
